const {isArray, map} = require("underscore");

/**
 * Reads a user's org/tier groups from a decoded token. Group membership lives
 * in the `cognito:groups` claim — on Cognito ID tokens directly, and on
 * Keycloak tokens via the oidc-cognito-mapper (backed by the `cognitoGroups`
 * attribute / the synced `/cognito` Keycloak groups projected into that claim).
 * Keycloak can emit the claim as a comma-separated string, so that form is
 * normalized to an array here.
 * @param {Object} user - Decoded token payload
 * @return {Array<string>} The user's groups (empty array when none)
 */
const getGroups = (user) => {
  let groups = user?.["cognito:groups"];
  if (typeof groups === "string") {
    groups = map(groups.split(","), (g) => g.trim());
  }
  return isArray(groups) ? groups : [];
};

/**
 * Reads a user's username from a decoded token in a backend-agnostic way.
 * Prefers `cognito:username` (Cognito, and Keycloak via the mapper), then
 * Keycloak's native `preferred_username`, then the subject id.
 * @param {Object} user - Decoded token payload
 * @return {string|undefined} The username
 */
const getUsername = (user) => user?.["cognito:username"] ?? user?.preferred_username ?? user?.sub;

module.exports = {
  getGroups,
  getUsername,
};
